import { render, staticRenderFns } from "./MedicalMenuItem.vue?vue&type=template&id=404145f8&scoped=true&"
import script from "./MedicalMenuItem.vue?vue&type=script&lang=ts&"
export * from "./MedicalMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./MedicalMenuItem.vue?vue&type=style&index=0&id=404145f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404145f8",
  null
  
)

export default component.exports